/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

/**
 * Small directive that handles node download
 *
 * It uses hidden iframe to load the file in OR (in case of errors) parse the body and display flash. Because of the file response, we cannot clean the iframes from
 * the DOM after load; so clean anything left whenever we start new download. At least we are stuck with only one iframe tag in the DOM
 */
angular.module('access.Nodes')
    .directive('accDownload', ['nodeDownload', function(nodeDownload) {
        return {
            scope: {
                node: '=accDownload',
                revision: '@'
            },
            link: function($scope, $element) {
                $element.on('click', function() {
                    nodeDownload($scope.node, $scope.revision);
                });
            }
        }
    }]);
 
 
